import { connect } from "react-redux";

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var UIActions = require("lib/actions/UIActions");
var OrgTypes = require("lib/academic/OrgTypes");

var DropDownOptions = require("components/utility/DropDownOptions");
var NumbersOnlyInput = require("components/utility/NumbersOnlyInput");
var PaywallModal = require("components/users/teachers/PaywallModal");
var StudentMetrics = require("lib/data/StudentMetrics");
var Features = require("lib/account/Features");
var Glyphicon = require("components/utility/icons/Glyphicon");
var GradeLevel = require("lib/academic/GradeLevel.js");
var CurrentUser = require("lib/account/CurrentUser");
var ExpectationsCustomizer = require("components/users/teachers/ExpectationsCustomizer");
var AltModal = require("components/utility/AltModal");
var RosterRouting = require("lib/routing/RosterRouting");
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

function triggerDifferentiationDropDown(student) {
	if (student) {
		var text = "You updated " + student.display_name + "."
	} else {
		var text = "You updated your students.";
	}
	window.wrNotifications.triggerDropDownNotification({
		title: "Success", text: text,
		icon: "ok-sign" })
}

@connect(
	(state, props) => {

		if (props.student) {
			var prefs = props.student.prefs;
		} else if (props.orgIdentifier) {
			var { type, key } = OrgTypes.fromIdentifier(props.orgIdentifier);

			if (type === OrgTypes.ALL_STUDENTS) {
				// Use one student lists's prefs as the overall defaults
				var prefs = RosterSelectors.globalStudentListPrefs({ state });

			} else if (type === OrgTypes.STUDENT_LIST) {
				var studentList = RosterSelectors.studentList({ state, id: key });
				var prefs = studentList.prefs;

			} else if (type === OrgTypes.SUBGROUP) {
				var subgroup = RosterSelectors.subgroup({ state, key: key });

				// Use one student in the group's prefs as the overall defaults
				var prefs = RosterSelectors.studentsForSubgroupKey({ state, subgroupKey: key })[0].prefs;
			}
		}

		return {
			prefs, studentList, subgroup,
			allowStudentDifferentiation: Features.isEnabled(Features.STUDENT_DIFFERENTIATION)			
		}
	},
	(dispatch, props) => ({
		updatePrefs: (update) => {
			if (props.student) {
				triggerDifferentiationDropDown(props.student);
				return dispatch(RosterActions.updateStudentPrefs({ studentID: props.student.id, update }));

			} else {
				var { type, key } = OrgTypes.fromIdentifier(props.orgIdentifier);

				if (type === OrgTypes.ALL_STUDENTS) {
					return dispatch(RosterActions.updateAllStudentListPrefs({
						update, currentUserID: CurrentUser.get().id, resetStudents: true
					}), triggerDifferentiationDropDown())

				} else if (type == OrgTypes.STUDENT_LIST) {
					return dispatch(RosterActions.updateStudentListPrefs({
						update, studentListID: key, resetStudents: true
					}), triggerDifferentiationDropDown())

				} else if (type == OrgTypes.SUBGROUP) {
					return dispatch(RosterActions.massUpdateStudentPrefs({
						update, subgroupKey: key,
						embeds: ["student.prefs"]
					}))

				}

			}
		},

		updateStudent: (studentID, update) =>
			dispatch(RosterActions.updateStudent({id: studentID, update, embeds: ["student.current_reading_level"]
		})),

		showDifferentiationPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.STUDENT_DIFFERENTIATION })),

		showZPDReadingLevelsPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.ZPD_READING_LEVELS })),

		openZpdPaywall: () => 
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.CLOZE_ASSESSMENTS }))
	}),
)
class DifferentiationRow extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = this.getInitialState();
		this.expectationsModal = React.createRef();
	}

	getInitialState() {
		return { 
			overrideGoals: {}, openFields: {},
			overrideQuizExpectations: {},
			overrideAcademicLevel: null,
			overrideReadingLevel: null,
			overrideSentenceStarter: null,
			overrideWarmupQuestions: null,
		}
	}

	isStudentRow() {
		return !!this.props.student;
	}
	isStudentListRow() {
		if (this.props.orgIdentifier) {
			return OrgTypes.fromIdentifier(this.props.orgIdentifier).type === OrgTypes.STUDENT_LIST;
		}
		return false
	}
	isSubgroupRow() {
		if (this.props.orgIdentifier) {
			return OrgTypes.fromIdentifier(this.props.orgIdentifier).type === OrgTypes.SUBGROUP;
		}
		return false
	}
	isGlobalRow() {
		if (this.props.orgIdentifier) {
			return OrgTypes.fromIdentifier(this.props.orgIdentifier).type === OrgTypes.ALL_STUDENTS;
		}
		return false
	}

	openAssignmentModal(e) {
		$wr.nope(e)
		this.expectationsModal.current.show();
	}

	rowLabel() {
		if (this.isStudentRow()) {
			return (
				<div className="ellipsisText">
					{ this.props.student.display_name }
				</div>
			);

		} else if (this.isStudentListRow()) {
			return (
				<div className="ellipsisText">
					{ this.props.studentList.name }<br />
					<span className="smallText">Classwide Defaults</span>
				</div>
			);

		} else if (this.isSubgroupRow()) {
			return (
				<div className="ellipsisText">
					{ this.props.subgroup.name }<br />
					<span className="smallText">Group Defaults</span>
				</div>
			);

		} else {
			return (
				<div className="ellipsisText">
					All Classes<br />
					<span className="smallText">Accountwide Defaults</span>
				</div>
			);
		}
	}

	changedAcademicLevel() {
		return this.state.overrideAcademicLevel !== null;
	}
	changedSentenceStarter() {
		return this.state.overrideSentenceStarter !== null;
	}
	changedWarmupQuestions() {
		return this.state.overrideWarmupQuestions !== null;
	}
	changedGoals() {
		return !_.isEmpty(this.state.overrideGoals);
	}
	changedQuizExpectations() {
		return !_.isEmpty(this.state.overrideQuizExpectations);
	}

	changedReadingLevels() {
		return !_.isEmpty(this.state.overrideReadingLevel);
	}

	hasChange() {
		return this.changedAcademicLevel() || this.changedSentenceStarter() || 
			this.changedWarmupQuestions() || this.changedGoals() || this.changedQuizExpectations() || this.changedReadingLevels();
	}

	setGoal(value, type) {
		var joined = _.extend({}, this.state.overrideGoals, { [type]: value })
		this.setOverride("overrideGoals", joined);
	}
	setQuizExpectations(value, type) {
		var joined = _.extend({}, this.state.overrideQuizExpectations, { [type]: value })
		this.setOverride("overrideQuizExpectations", joined);
	}
	setReadingLevel(value, type) {
		var joined = _.extend({}, this.state.overrideReadingLevel, { [type]: value })
		this.setOverride("overrideReadingLevel", joined);
	}
	setOverride(key, value) {
		if (this.isStudentRow() && !this.props.allowStudentDifferentiation) {
			if (this.props.activeView == RosterRouting.VIEWS.GOALS) {
				this.props.showDifferentiationPaywall();				
			} else {
				this.props.showZPDReadingLevelsPaywall();
			}
			return;
		}

		this.setState({ [key]: value })
	}

	changeGoal(field, e) {
		$wr.nope(e)
		var joined = _.extend({}, this.state.openFields, { [field]: true })
		this.setState({ openFields: joined })
	}
	addQuizExpectations(update) {
		if (this.changedQuizExpectations()) {
			// UPDATE RECALL COUNT IF OVERIDDED
			var recall_question_count = this.state.overrideQuizExpectations[StudentMetrics.QUIZ_OPTIONS.RECALL_QUESTIONS]

			if (recall_question_count != undefined) {
				update.recall_question_count = parseInt(recall_question_count)
			}

			// GRAB ANALYSIS QUESTION COUNT FROM OVERRIDE OR PREFS
			var analysis_question_count = this.state.overrideQuizExpectations[StudentMetrics.QUIZ_OPTIONS.ANALYSIS_QUESTIONS]

			if (analysis_question_count != undefined) {
				var analysisOveride = true
			} else {
				var analysisOveride = false
				analysis_question_count = this.prefs().analysis_question_count > 0 ? this.prefs().analysis_question_count : this.prefs().sentence_starter_count
			}

			// IF SENTENCE STARTER CHANGED UPDATE QUESTIONS COUNTS
			var sentence_starter_count = this.state.overrideQuizExpectations[StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS]
			if (sentence_starter_count != undefined) {
				if (sentence_starter_count == "On") {
					update.sentence_starter_count = parseInt(analysis_question_count)
					update.analysis_question_count = 0
				} else {
					update.sentence_starter_count = 0
					update.analysis_question_count = parseInt(analysis_question_count)
				}
			} else {
				if (analysisOveride) {
					if (this.prefs().sentence_starter_count > 0) {
						update.sentence_starter_count = parseInt(analysis_question_count)
					} else {
						update.analysis_question_count = parseInt(analysis_question_count)
					}
				}
			}
		}
	}
	submit(e) {
		$wr.nope(e)

		if (!this.isStudentRow()) {
			var confirmParts = [];
			if (this.changedAcademicLevel()) {
				confirmParts.push("academic level")
			}
			if (this.changedGoals()) {
				confirmParts.push("goals")
			}
			if (this.changedSentenceStarter()) {
				confirmParts.push("sentence starters")
			}
			if (this.changedWarmupQuestions()) {
				confirmParts.push("warmup questions")
			}
			if (this.changedQuizExpectations()) {
				confirmParts.push("quiz composition")
			}
			var confirmMessage = "This will change";
			if (confirmParts.length == 1) {
				confirmMessage += " " + confirmParts[0];
			} else if (confirmParts.length == 2) {
				confirmMessage += " " + confirmParts.join(" and ");
			} else {
				confirmMessage += " " + confirmParts.slice(0, confirmParts.length - 1).join(", ") +
					", and " + _.last(confirmParts);
			}

			confirmMessage += " for all your students";
			if (this.isStudentListRow()) {
				confirmMessage += " in this class"
			}
			confirmMessage += ".";

			if (!confirm(confirmMessage)) {
				return;
			}
		}
		
		var update = {}

		if (this.changedAcademicLevel()) {
			update.academic_level = this.state.overrideAcademicLevel;
		}
		if (this.changedSentenceStarter()) {
			update.sentence_starter_count = this.state.overrideSentenceStarter;
		}
		if (this.changedWarmupQuestions()) {
			update.active_warmup_questions = this.state.overrideWarmupQuestions;
		}

		if (this.changedGoals()) {
			var expectations = this.prefs().expectations_metrics;
			update.expectations_metrics = _.map(expectations, ({ metric, goal }) => {
				var override = this.state.overrideGoals[metric];
				if (override === undefined) {
					var value = goal; // Stays the original goal
				} else if (override.trim().length == 0) {
					var value = 0;
				} else {
					var value = parseInt(override);
				}
				return { metric, goal: value }
			});
		}

		if (this.changedReadingLevels()) {
			var readingLevelValue = this.refs.lexile.value
			var params = { current_reading_level: readingLevelValue };
			this.props.updateStudent(this.props.student.id, params)
		}
		this.addQuizExpectations(update)
		
		this.props.updatePrefs(update);
		this.setState(this.getInitialState());
	}

	getGoalText(metric) {
		return StudentMetrics.getLabel(metric);
	}

	prefs() {
		return this.props.prefs;
	}

	renderExpectationsModal() {
		if (this.isStudentListRow()) {
			var headerText = this.props.studentList.name + " Goals";
		} else {
			var headerText = "Accountwide Goals";
		}
		return (
			<AltModal className="expectationsModal" ref={ this.expectationsModal }
				headerText={ headerText }>
				<ExpectationsCustomizer askConfirmation orgIdentifier={ this.props.orgIdentifier } />
			</AltModal>
		);
	}

	renderAcademicLevel() {
		if (this.state.overrideAcademicLevel === null) {
			var value = this.prefs().academic_level;
		} else {
			var value = this.state.overrideAcademicLevel;
		}

		if (this.isStudentRow() || this.state.openFields["academic_level"]) {
			var cellContent = (
				<select value={ value } className="form-control studentEditSelectField gradeSelect"
					onChange={ (e) => this.setOverride("overrideAcademicLevel", e.target.value) }>
					{ DropDownOptions.Select.GradeLevels() }
				</select>
			);
		} else {
			var cellContent = (
				<span className="defaultVal">
					{ GradeLevel.getShortName(value) }{" "}
					<a href="#" className="editLink"
						onClick={ this.changeGoal.bind(this, "academic_level") }>
						Edit
					</a>
				</span>
			);
		}
		return (
			<div className="infoSection academicLevelCell">
				{ cellContent }
			</div>
		);
	}
	// defaultReadingLevel() {
	// 	var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
	// 	return ReadingLevelFormat.getLexileScoreForFormat(
	// 		this.props.student.current_reading_level, readingLevelFormat
	// 	);
	// }
	formattedReadingLevel() {
		var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
		return ReadingLevelFormat.getScoreForFormat(
			this.props.student.current_reading_level, readingLevelFormat
		);
	}
	triggerRLDPaywall() {
		this.props.openZpdPaywall();
	}
	renderReadingLevel() {
		var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
		if (this.props.student) {
			var value = this.formattedReadingLevel();
		}

		if (this.isStudentRow()) {
			if (this.state.openFields["reading_level"]) {
				var cellContent = (
					<select ref="lexile" defaultValue={ this.formattedReadingLevel() }
						className="form-control" onChange={ (e) => this.setReadingLevel(e.target.value, "current_reading_level") }>
						{ DropDownOptions.Select.ReadingLevels({lexile_to_formats: readingLevelFormat }) }
					</select>
				);
			} else {
				var cellContent = (
					<span className="defaultVal">
						{ value }
						<a href="#" className="editLink"
							onClick={ this.changeGoal.bind(this, "reading_level") }>
							Edit
						</a>
					</span>
				);
			}
		} else {
			if (!Features.isEnabled(Features.CLOZE_ASSESSMENTS) && Features.isEnabled(Features.HISTORICAL_DATA)) {
				var cellContent = (
					<span className="defaultVal">
						<a className="editLink editClassLink"
							onClick={ this.triggerRLDPaywall.bind(this) }>
							Start classwide assessment
						</a>
					</span>
				);
			}
		}

		return (
			<div className="infoSection academicLevelCell">
				{ cellContent }
			</div>
		);
	}

	renderQuizGoals() {		
		var prefs = this.prefs()
		var expectations = prefs.expectations_metrics.filter(({metric, goal}) => {return metric == "quizzes-passed"})

		expectations.push({metric: StudentMetrics.QUIZ_OPTIONS.RECALL_QUESTIONS, goal: prefs.recall_question_count})

		// IF SENTENCE STARTER PRESENT TRANSLATE INTO ANALYSIS QUESTIONS
		if (prefs.sentence_starter_count > 0) {
			var analysis_count = prefs.sentence_starter_count
			var sentence_starter = "On"
		} else {
			var analysis_count = prefs.analysis_question_count
			var sentence_starter = "Off"
		}
		expectations.push({metric: StudentMetrics.QUIZ_OPTIONS.ANALYSIS_QUESTIONS, goal: analysis_count})
		expectations.push({metric: StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS, goal: sentence_starter})
		
		var periodName = $wr.capitalize(
			$wr.Constants.PERIOD_TO_NAME[this.prefs().expectations_time_period]
		);

		if (this.isStudentRow()) {
			var editIcon = (
				<span>
					<Glyphicon icon="pencil" className="editIcon" />
				</span>
			);
		}

		if (expectations.length == 0) {
			if (this.isStudentRow()) {
				var goalsContainers = (
					<span>No Assignment</span>
				)
			} else {
				var overallExpectations = (
					<span onClick={ this.openAssignmentModal }>
						No Assignment
						{ editIcon }
					</span>
				)
			}
		} else {
			var goalsContainers = _.map(expectations, ({ metric, goal }) => {
				if (this.state.overrideGoals[metric] === undefined) {
					var value = goal;
				} else {
					var value = this.state.overrideGoals[metric];
				}

				if (metric == "quizzes-passed") {
					var frequency = "/" + periodName
				}
				if (this.state.openFields[metric]) {
					var options = StudentMetrics.getOptions(metric)
					if (options) {
						var input = (
							<select type="text" className="goalInput" ref={metric}
									defaultValue={ goal } onChange={(e) => {this.setQuizExpectations(this.refs[metric].value, metric)}}>
									{ options }
							</select>
						)
					} else {
						var input = (
							<NumbersOnlyInput value={ value } className="goalInput"
									onChange={ (e) => this.setGoal(e.target.value, metric) }
									autoFocus />
						)
					}
					return (
						<div className="goalContainer" key={ metric }>
							<span className="goalTitle">{ this.getGoalText(metric)}</span>
							{ input }
						</div>		
					);
				} else if (this.isStudentRow()) {
					// var options = StudentMetrics.getOptions(metric)
					// if (options) {
					// 	var input = (
					// 		<select type="text" className="goalInput" ref={metric}
					// 				defaultValue={ goal } onChange={(e) => {this.setGoal(metric, this.refs[metric].value)}}>
					// 				{ options }
					// 		</select>
					// 	)
					// } else {
						var input = (
							<span className="goalInput" onClick={ this.changeGoal.bind(this, metric) }>
								{ value } 
							</span>
						)
					// }
					return (
						<div className="goalContainer" key={ metric }>
							<span className="goalTitle">{ this.getGoalText(metric) }</span>
							{ input }
							{ editIcon }
						</div>	
					);
				} else {
					return (
						<div className="goalContainer" key={ metric }>
							<span className="goalTitle">{ this.getGoalText(metric) }</span>
							<span>
								{ value }
							</span>
							{frequency}
						</div>	
					);
				}
			})
			if (this.isStudentRow()) {
				var className = "studentGoalsSection";
			} else {
				var periodName = $wr.capitalize(
					$wr.Constants.PERIOD_TO_NAME[this.prefs().expectations_time_period]
				);
				// var overallExpectations = (
				// 	<div className="goalContainer">
				// 		<span className="goalTitle">Time Period</span>
				// 		<span>
				// 			{ periodName }
				// 		</span>
				// 	</div>
				// );
				var overallEdit = (
					<a className="btn-link overallEdit" href="#"
						onClick={ this.openAssignmentModal }>
						Edit
					</a>
				);
			}
		}
		
		return (
			<div className="infoSection quizzesCell">
				<div className={ "goalsSection " + className }>
					{ goalsContainers }
					{ overallExpectations }
				</div>
				{ overallEdit }
			</div>
		)
	}

	renderPracticeGoals() {	
		var filtered_metrics = this.prefs().expectations_metrics.filter(({metric, goal}) => 
				{return StudentMetrics.PRACTICE_EXPECTATION_METRICS.includes(metric)}
			);

		var expectations = _.sortBy(filtered_metrics, "metric");

		if (this.isStudentRow()) {
			var editIcon = (
				<span>
					<Glyphicon icon="pencil" className="editIcon" />
				</span>
			);
		}

		if (expectations.length == 0) {
			if (this.isStudentRow()) {
				var goalsContainers = (
					<span>No Assignment</span>
				)
			} else {
				var overallExpectations = (
					<span onClick={ this.openAssignmentModal }>
						No Assignment
						{ editIcon }
					</span>
				)
			}
		} else {
			var goalsContainers = _.map(expectations, ({ metric, goal }) => {
				if (this.state.overrideGoals[metric] === undefined) {
					var value = goal;
				} else {
					var value = this.state.overrideGoals[metric];
				}

				if (this.state.openFields[metric]) {
					return (
						<div className="goalContainer" key={ metric }>
							<span className="goalTitle">{ this.getGoalText(metric)}</span>
							<NumbersOnlyInput value={ value } className="goalInput"
								onChange={ (e) => this.setGoal(e.target.value, metric) }
								autoFocus />
						</div>		
					);
				} else if (this.isStudentRow()) {
					return (
						<div className="goalContainer" key={ metric }>
							<span className="goalTitle">{ this.getGoalText(metric) }</span>
							<span className="goalInput" onClick={ this.changeGoal.bind(this, metric) }>
								{ value }
							</span>
							{ editIcon }
						</div>	
					);
				} else {
					return (
						<div className="goalContainer" key={ metric }>
							<span className="goalTitle">{ this.getGoalText(metric) }</span>
							<span>
								{ value }
							</span>
						</div>	
					);
				}
			})
			if (this.isStudentRow()) {
				var className = "studentGoalsSection";
			} else {
				var periodName = $wr.capitalize(
					$wr.Constants.PERIOD_TO_NAME[this.prefs().expectations_time_period]
				);
				// var overallExpectations = (
				// 	<div className="goalContainer">
				// 		<span className="goalTitle">Time Period</span>
				// 		<span>
				// 			{ periodName }
				// 		</span>
				// 	</div>
				// );
				var overallEdit = (
					<a className="btn-link overallEdit" href="#"
						onClick={ this.openAssignmentModal }>
						Edit
					</a>
				);
			}
		}

		return (
			<div className="infoSection practiceCell">
				<div className={ "goalsSection " + className }>
					{ goalsContainers }
					{ overallExpectations }
				</div>
				{ overallEdit }
			</div>
		)
	}

	sentenceStarterText(index) {
		if (index == 0) {
			return "No starters";
		} else if (index == 1) {
			return "First question only";
		} else if (index == 2) {
			return "All questions";
		}
	}

	renderSentenceStarters() {
		if (this.state.overrideSentenceStarter === null) {
			var value = this.prefs().sentence_starter_count;
		} else {
			var value = this.state.overrideSentenceStarter;
		}

		if (this.isStudentRow() || this.state.openFields["sentence_starter_count"]) {
			var cellContent = (
				<select value={ value } className="form-control studentEditSelectField gradeSelect"
					onChange={ (e) => this.setOverride("overrideSentenceStarter", e.target.value) }>
					<option value={ 0 }>{ this.sentenceStarterText(0) }</option>
					<option value={ 1 }>{ this.sentenceStarterText(1) }</option>
					<option value={ 2 }>{ this.sentenceStarterText(2) }</option>
				</select>
			);
		} else {
			var cellContent = (
				<span className="defaultVal">
					{ this.sentenceStarterText(value) }{" "}
					<a href="#" className="editLink"
						onClick={ this.changeGoal.bind(this, "sentence_starter_count") }>
						Edit
					</a>
				</span>
			);
		}

		return (
			<div className="infoSection sentenceStarterCell">
				{ cellContent }
			</div>
		);

	}


	renderWarmupQuestions() {
		if (this.state.overrideWarmupQuestions === null) {
			var value = this.prefs().active_warmup_questions;
		} else {
			var value = this.state.overrideWarmupQuestions;
		}

		if (this.isStudentRow() || this.state.openFields["active_warmup_questions"]) {
			var cellContent = (
				<select value={ value + "" } className="form-control studentEditSelectField gradeSelect"
					onChange={ (e) => this.setOverride("overrideWarmupQuestions", e.target.value) }>
					{ DropDownOptions.Select.DifferentiatedLearning() }
				</select>
			);
		} else {
			var cellContent = (
				<span className="defaultVal">
					{ value ? "On" : "Off" }{" "}
					<a href="#" className="editLink"
						onClick={ this.changeGoal.bind(this, "active_warmup_questions") }>
						Edit
					</a>
				</span>
			);
		}

		return (
			<div className="infoSection warmupCell">
				{ cellContent }
			</div>
		);
	}

	render() {
		if (this.hasChange()) {
			var saveLink = (
				<div className="saveCell">
					<a className="saveLink" href="#" onClick={ this.submit }>Save</a>	
				</div>
			)
		}


		if (!this.isStudentRow()) {
			var expectationModal = this.renderExpectationsModal();
		}

		if (this.props.activeView == RosterRouting.VIEWS.GOALS) {
			var data = (
				<div className="dataContainer">
					<div className="infoSection academicLevelCell"></div>
					{ this.renderQuizGoals() }
					{ this.renderPracticeGoals() }
				</div>
			)
		} else {
			var data = (
				<div className="dataContainer">
					<div className="infoSection firstEmptyCell"></div>
					{ this.renderAcademicLevel() }
					<div className="infoSection lastEmptyCell"></div>
					{ this.renderReadingLevel() }
				</div>
			)
		}

		return (
			<div className="differentiationRow">
				<div className="rowContent">
					<div className="">
						<div className="ellipsisText studentNameCell">
							{ this.rowLabel() }
						</div>
						{ data }
						{ saveLink }
						{ expectationModal }
					</div>
				</div>
			</div>
		)
	}

	componentDidMount() {
		if ($wr.getURLParameterByName("edit_expectations") && !this.isStudentRow()) {
			this.expectationsModal.current.show();
		}
	}
};

DifferentiationRow.propTypes = StrictPropTypes({
	student: PropTypes.object,
	orgIdentifier: PropTypes.string,
	activeView: PropTypes.string,

	// Data from @connect
	allowStudentDifferentiation: PropTypes.bool,
	studentList: PropTypes.object,
	subgroup: PropTypes.object,
	prefs: PropTypes.object,

	// Handlers from @connect
	showDifferentiationPaywall: PropTypes.func,
	updatePrefs: PropTypes.func

});

module.exports = DifferentiationRow;


// WEBPACK FOOTER //
// ./modules/components/org/differentiation/DifferentiationRow.js